import { Link, Navigate } from '@tanstack/react-router'
import { Alert, Mono, StageBadge } from '../components/ui'
import { errorMessage } from '../lib/api'
import { formatAmount, formatDate } from '../lib/format'
import { useMyCases } from '../lib/participants'
import { useMe } from '../lib/session'

/** Financing requests the signed-in user reaches as a borrower. */
export function MyCasesPage() {
  const me = useMe()
  const cases = useMyCases(me.data !== null && me.data !== undefined)

  if (me.data === null) return <Navigate to="/sign-in" />
  if (cases.isPending || !me.data) return <p className="text-sm text-neutral-500">Loading…</p>
  if (cases.isError) return <Alert tone="error">{errorMessage(cases.error)}</Alert>

  return (
    <section className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold text-neutral-900">Your financing requests</h1>
        <p className="mt-1 text-sm text-neutral-500">Requests a dealer has shared with {me.data.user.email}.</p>
      </div>

      {cases.data.cases.length === 0 ? (
        <Alert tone="info">
          Nothing here yet. If a dealer sent you a financing link, open it while signed in as the address it was sent to.
        </Alert>
      ) : (
        <ul className="divide-y divide-neutral-100 rounded-xl border border-[var(--border-subtle)] bg-white shadow-sm">
          {cases.data.cases.map((c) => (
            <li key={c.participant_id}>
              <Link to="/cases/$caseId" params={{ caseId: c.case_id }} className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 text-sm hover:bg-neutral-50">
                <div className="space-y-0.5">
                  <div className="flex items-center gap-2">
                    <span className="font-medium" style={c.dealer.accent_color ? { color: c.dealer.accent_color } : undefined}>
                      {c.dealer.display_name}
                    </span>
                    <StageBadge stage={c.stage} />
                  </div>
                  <div className="text-neutral-500">{c.equipment_summary}</div>
                  <div className="text-xs text-neutral-400">
                    <Mono>{c.reference}</Mono> · {c.buyer_business_name} · opened {formatDate(c.created_at)}
                  </div>
                </div>
                <div className="text-right">
                  <Mono className="font-semibold">{formatAmount(c.requested_principal)}</Mono>
                  <div className="text-xs text-neutral-500">{c.application_submitted ? 'Application submitted' : 'Application not started'}</div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
